import mapService from '@/api/map'
import {MAP, LOCKER, DESK} from "../types";
import strings from '@/strings'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    startPoints: [],
  },
  mutations: {
    [MAP.SET_START_POINTS](state, startPoints) {
      state.startPoints = startPoints
    },
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    getMap: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getMap(locationId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getMapWayfinding: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getMapWayfinding(locationId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getMapWayfindingAdmin: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getMapWayfindingAdmin(locationId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getWayfindingStartPoints: function ({commit}, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getWayfindingStartPoints(locationId).then((response) => {
          commit(MAP.SET_START_POINTS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getMapAdmin: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getMapAdmin(locationId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setMap: function ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        mapService.setMap(obj.locationId, obj.map).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    setMapWayfinding: function ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        mapService.setMapWayfinding(obj.locationId, obj.map).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getMapPosition: function ({ commit }, locationId) {
      return new Promise((resolve, reject) => {
        mapService.getMapPosition(locationId).then((response) => {
          const { deskPattern, lockerPattern, desksCount, desks, lockers } = response.data
          let myMapDesk = new Map()
          let myMapLocker = new Map()


          desks.forEach((item) => {
            myMapDesk.set(item.id, item)
          })

          lockers.forEach((item) => {
            myMapLocker.set(item.id, item)
          })

          commit('Desk/' + DESK.DESK_SET, myMapDesk, { root: true })
          commit('Desk/' + DESK.DESKS_COUNT_SET, desksCount, { root: true })
          commit('Desk/' + DESK.PATTERN_SET, deskPattern, { root: true })

          commit('Locker/' + LOCKER.LOCKER_SET, myMapLocker, { root: true })
          commit('Locker/' + LOCKER.PATTERN_SET, lockerPattern, { root: true })
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveMapPosition: function ({ dispatch, rootState }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        const desks = Array.from(rootState.Desk.desks.values())
          .filter(desk => desk.state != strings.pinStatus.none)

        const lockers = Array.from(rootState.Locker.lockers.values())
          .filter(locker => locker.state != strings.pinStatus.none)

        const queryParams = { locationId: obj.locationId }
        const bodyParams = { deskPattern: rootState.Desk.pattern, lockerPattern: rootState.Locker.pattern, desks , lockers}
        const params = { queryParams, bodyParams }


        mapService.saveMapPosition(params.queryParams, params.bodyParams).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    async getMapWithInterestZonesUrl(_, payload) {
      try {
        const response = await mapService.getMapWithInterestZonesUrl(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
  }
}
